import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Card, Table } from "react-bootstrap";
import { toast } from "../../../components/AppToast";
import { fetchPricingFoundationCustomerSkus } from "../../../services/pricingFoundation/pricingFoundation";

export default function CustomerSkuPricingList() {
  const userDetail = useSelector((state) => state?.login?.userDetail);
  const organizationCustomerId = String(
    userDetail?.organizationCustomerId?._id ??
      userDetail?.organizationCustomerId ??
      userDetail?.customerId ??
      ""
  ).trim();
  const [rows, setRows] = useState([]);
  const [loadingRows, setLoadingRows] = useState(false);

  const loadCustomerSkus = useCallback(async (customerId) => {
    if (!customerId) {
      setRows([]);
      return;
    }
    setLoadingRows(true);
    try {
      const raw = await fetchPricingFoundationCustomerSkus(customerId);
      const list = Array.isArray(raw) ? raw : [];
      const formatted = list.map((item, idx) => ({
        id: item._id || item.id || `${item.skuId || "sku"}-${idx}`,
        skuId: item.skuId || item.sku_id || item.skuid || "—",
        description: item.description || item.skuDescription || "—",
        originalPrice: item.originalPrice ?? item.original_price ?? "",
        sellingPrice: item.sellingPrice ?? item.selling_price ?? "",
        customerGroup: item.customerGroup || item.customer_group || "—",
      }));
      setRows(formatted);
    } catch (err) {
      console.error(err);
      toast.error(typeof err === "string" ? err : "Failed to load customer SKU pricing");
      setRows([]);
    } finally {
      setLoadingRows(false);
    }
  }, []);

  useEffect(() => {
    loadCustomerSkus(organizationCustomerId);
  }, [loadCustomerSkus, organizationCustomerId]);

  return (
    <Card className="border-0 shadow-sm">
      <Card.Body className="p-0">
        {!organizationCustomerId ? (
          <div className="text-center py-5 text-secondary small">
            Organization customer ID not found for logged in user.
          </div>
        ) : loadingRows ? (
          <div className="text-center py-5 text-secondary small">Loading…</div>
        ) : (
          <div className="table-responsive">
            <Table hover className="mb-0 align-middle">
              <thead className="table-light">
                <tr>
                  <th>SKU ID</th>
                  <th>Description</th>
                  <th>Purchase Price</th>
                  <th>Selling Price</th>
                  <th>Supplier Group</th>
                </tr>
              </thead>
              <tbody>
                {rows.length ? (
                  rows.map((row) => (
                    <tr key={row.id}>
                      <td>{row.skuId}</td>
                      <td>{row.description}</td>
                      <td>{row.originalPrice !== "" ? Number(row.originalPrice).toFixed(2) : "—"}</td>
                      <td>{row.sellingPrice !== "" ? Number(row.sellingPrice).toFixed(2) : "—"}</td>
                      <td>{row.customerGroup}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center py-4 text-secondary small">
                      No SKU pricing found for your customer mapping.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </Card.Body>
    </Card>
  );
}
